// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_uc-0";